"use client";

import { useNumberAnimation } from "@/hooks/useNumberAnimation";

interface NumberCounterProps {
  initialNumber: number;
  targetNumber: number;
}

export const NumberCounter = ({
  initialNumber,
  targetNumber,
}: NumberCounterProps) => {
  const animatedNumber = useNumberAnimation(initialNumber, targetNumber);

  return (
    <div className="flex items-center gap-2.5">
      {animatedNumber
        .toLocaleString("en-US")
        .split("")
        .map((char, index) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: Character position in animated number is stable
            key={`digit-${index}`}
            className="flex h-12 flex-col items-center justify-end overflow-hidden font-suisse text-5xl font-bold leading-12 text-foreground"
          >
            {char}
          </div>
        ))}
    </div>
  );
};
